import axios from 'axios';

const LOCAL = 'http://127.0.0.1:5000';
// change port to 3000 if your frontend runs on 3000 port
let IFRAME_BASE_URL = 'http://127.0.0.1:3001';
let BASE_URL;

// Always verify that ClientDashboard is running on localhost:3000 locally
if (window.location.port === '3000') {
    BASE_URL = LOCAL;
}else {
    BASE_URL = window.location.origin;
    IFRAME_BASE_URL = window.location.origin;
}

const service = axios.create({
    timeout: 29000, // request timeout
    baseURL: BASE_URL
});
const cookieQuestion = 'HAS_CLICKED_QUESTION_AWAY';
const cookieAcceptance = 'COOKIES_ACCEPTED';

// request interceptor

service.interceptors.request.use(
    config => {
        // Do something before request is sent

        config.headers["Authorization"] = ``

        const token1 = getToken();
        if (token1 && config.url.indexOf('/login') === -1) {
            config.headers["Authorization"] = `Basic ${btoa(token1 + ':')}`
        }
        return config;
    },
    error => {
        Promise.reject(error);
    }
);

const getToken = () => {
    return localStorage.getItem('auth');
}

const setToken = (token) => {
    localStorage.setItem('auth', token);
}

const removeToken = () => {
    localStorage.removeItem('auth');
}

const getCookieQuestionAsked = () => {
    if (localStorage.getItem(cookieQuestion)) {
        return true
    } else {
        return false
    }
}

const setCookieQuestionAsked = () => {
    return localStorage.setItem(cookieQuestion, 'True')
}

const getCookieAcceptance = () => {
    if (localStorage.getItem(cookieAcceptance)) {
        return true
    } else {
        return false
    }
}

const setCookieAcceptance = () => {
    return localStorage.setItem(cookieAcceptance, 'True')
}

export {
    service,
    setToken,
    getToken,
    removeToken,
    getCookieQuestionAsked,
    setCookieQuestionAsked,
    getCookieAcceptance,
    setCookieAcceptance,
    BASE_URL,
    IFRAME_BASE_URL
}
